export const APP_BASE_PATH = '/auth';

/** The Profile page's full same-origin path (base included), used for guards and `returnUrl`s. */
export const PROFILE_PATH = `${APP_BASE_PATH}/profile`;

/**
 * The retired Security page's full same-origin path. Kept only so the `/auth/security` route can
 * redirect inbound links to {@link PROFILE_PATH} until sibling apps migrate.
 */
export const SECURITY_PATH = `${APP_BASE_PATH}/security`;
